import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { CreateGovernmentAllocationValidationSchema } from '@/features/privateCompanies/schemas/createGovernmentAllocation.schema'
import { useMutation } from '@tanstack/react-query'

type CreateGovernmentAllocationProps = {
  onSuccess: () => void
  onError: (error: any) => void
}

export const useCreateGovernmentAllocation = ({ onSuccess, onError }: CreateGovernmentAllocationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createGovernmentAllocation'],
    mutationFn: async ({ form }: { form: CreateGovernmentAllocationValidationSchema }) => {
      const government_allocation = {
        branch_id: form.branch_id.value,
        start_of_document_validity: form.start_of_document_validity,
        end_of_document_validity: form.end_of_document_validity,
        office_number: form.office_number,
        total_value: unFormatCurrency(form.total_value),
        force_post_paid: form.file_required?.value === 'force_post_paid' ? true : false,
        bypass_file_presence: form.file_required?.value === 'bypass_file_presence' ? true : false,
        file: form.file,
      }

      return privateAxios.postForm('/billing/government_allocations', {
        government_allocation,
      })
    },
    onSuccess: onSuccess,
    onError: onError,
  })
}
